<template>
  <div class="osk-products-filters-price">
    <div class="osk-products-filters-price__title">
      Диапазон цен
    </div>

    <div class="osk-products-filters-price__content">
      <UikitFormInputPrice
        v-model="price.lower"
        name="lower"
        size="l"
        text-left="От"
        :min="filterInfo.lower"
        :max="filterInfo.upper"
        @blur="handleBlur('lower')"
      />

      <UikitFormInputPrice
        v-model="price.upper"
        name="upper"
        size="l"
        text-left="До"
        :min="filterInfo.lower"
        :max="filterInfo.upper"
        @blur="handleBlur('upper')"
      />
    </div>

    <UikitFormFieldCaption
      :message="error"
      error
      class="osk-products-filters-price__error"
    />
  </div>
</template>

<script lang="ts" setup>
import { PriceFilter, PriceValue } from '~/restAPI/data-contracts';
import { AnalyticsEvents } from '~/types/analytics';

const { $addEvent } = useNuxtApp();

const props = defineProps<{
  filterInfo: PriceFilter
  page?: string
}>();

const emits = defineEmits<{
  (e: 'updateFilter', value?: PriceValue): void,
}>();

const price = ref(genPrice());

const error = computed(() => {
  if ((price.value.lower ?? 0) > (price.value.upper ?? 0)) {
    return 'Верхнее значение не может быть меньше нижнего';
  }

  return undefined;
});

function handleBlur(value: 'lower' | 'upper') {
  $addEvent(AnalyticsEvents.FiltersLinkClick, {
    chapter: 'price',
    value,
    id_chapter: String(price.value[value]),
    page: props.page,
  });
}

function genPrice() {
  const { filterInfo } = props;

  return {
    lower: filterInfo.selectedLower || filterInfo.lower,
    upper: filterInfo.selectedUpper || filterInfo.upper,
  };
}

watch(price, (value) => {
  emits('updateFilter', value);
}, { deep: true });

watch(() => props.filterInfo, () => {
  price.value = genPrice();
}, { deep: true });
</script>

<style scoped lang="scss">
@import "~/assets/scss/settings/index";

.osk-products-filters-price {
  position: relative;

  @include media-query(lg-and-up) {
    margin-top: -20px;
  }

  &__title {
    font-weight: 700;
    font-size: 22px;
    line-height: 27px;
    margin-bottom: 34px;

    @include media-query(lg-and-up) {
      @include font-style($font-size-heading, $line-height-heading, $font-weight-bold);
      margin-bottom: $indent-large;
    }
  }

  &__content {
    display: flex;
    align-items: center;

    :deep(.osk-field__inner) {
      @include media-query(lg-and-up) {
        border-color: #000;
      }
    }

    :deep(.osk-input__input) {
      height: 40px;
      line-height: 40px;

      @include media-query(lg-and-up) {
        height: 42px;
        line-height: 42px;
      }
    }
  }

  :deep(.osk-input) {
    margin-top: 0;

    &:not(:last-child) {
      margin-right: $indent-compact;
    }
  }

  &__error {
    position: relative;

    :deep(.osk-field-caption__content) {
      padding-top: 8px;
      padding-left: 4px;

      @include media-query(lg-and-up) {
        padding-top: 12px;
        padding-left: 0;
      }
    }
  }
}
</style>
